<template>
    <div class="col-xs-12 col-md-12 col-lg-12 col-xl-12">
        <span class="timestamp-hour">{{ transaction_data.log_time }}</span>
        <span class="message-bg">
            <template
                    v-if="transaction_data.action_metadata && transaction_data.action_metadata.action_name && transaction_data.action_metadata.action_name !== ''">
                <span>{{transaction_data.action_metadata.action_name}}</span><br>

                <template
                        v-if="transaction_data.action_metadata.entity_name && transaction_data.action_metadata.entity_name !== ''">
                    <span>Entity: {{transaction_data.action_metadata.entity_name}}</span><br>
                </template>

                <template
                        v-if="transaction_data.action_metadata.domain_name && transaction_data.action_metadata.domain_name !== ''">
                    <span>Domain: {{transaction_data.action_metadata.domain_name}}</span><br>
                </template>
            </template>
            <template v-else>
                <span class="target">Type: </span>
                <span class="message">{{ transaction_data.action_type }}</span><br>
            </template>

            <span>Status:
                <span :class="transaction_data.status_class">
                    <template v-if="transaction_data.status.toLowerCase() == 'in progress'">
                        <fa icon="spinner" spin/>
                    </template>
                    {{ transaction_data.status }}
                </span>
            </span>
            <br>
            <span><em>by: {{ transaction_data.username }}</em></span>

            <h5>Transactions</h5>
            <b-table
                    striped
                    hover
                    :items="transactions.all()"
                    :fields="table_fields"
                    sort-by="id"
                    :sort-desc="true"
                    :show-empty="true"
                    empty-text="There are no transactions available."
            >
                <template v-slot:cell(transaction_id)="data">
                    {{ data.item.id }}
                </template>
                <template v-slot:cell(transaction_name)="data">
                    <template v-if="data.item.has_fetch_error">error reading transaction</template>
                    <template v-else>
                        {{data.item.transaction_metadata.transaction_name}}
                    </template>
                </template>
                <template v-slot:cell(transaction_details)="data">
                    <template v-if="data.item.has_fetch_error">{{data.item.fetch_error_text}}</template>
                    <template v-else>
                        <template v-if="data.item.transaction_metadata.entity_name">Entity: {{data.item.transaction_metadata.entity_name}}<br></template>
                        <template v-if="data.item.transaction_metadata.domain_name">Domain: {{data.item.transaction_metadata.domain_name}}<br></template>
                    </template>
                </template>
                <template v-slot:cell(status)="data">
                    {{ data.item.status }}
                </template>
            </b-table>
        </span>
    </div>
</template>
<script>

	export default {
		components: {},
		mounted()
		{
			console.log('transaction_data transaction_data ', this.transaction_data);
		},
		props: {
			transaction_data: {
				type: Object,
				default: () => {
					return {
						transaction_name: "Unknown transaction name",
					}
				}
			},
		},
		data()
		{
			let my_table_fields = [
				{
					key: "transaction_id",
					label: "Id",
					sortable: false
				},
				{
					key: "transaction_name",
					label: "Transaction name",
					sortable: false
				},
				{
					key: "transaction_details",
					label: "Details name",
					sortable: false
				},
				{
					key: "status",
					label: "Status",
					sortable: false
				},
			];

			return {
				table_fields: my_table_fields,
            };
		},
		computed: {
			transactions: function() {
				let transactions = [];

				for (let [key, value] of Object.entries(this.transaction_data.action_details)) {
					transactions.push({id: key, ...value})
				}

				return this.$collect(transactions);
            }
        },
		watch: {},
		methods: {}
	};
</script>
